import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import usePDPKeySellingPoints from 'data-hooks/usePDPKeySellingPoints';
import Placeholder from 'components/consumer/Placeholder';
import StandardModal from 'components/consumer/StandardModal';
import IconReturns from 'components/icons/iconReturns';
import IconMaterialsDesigned from 'components/icons/iconMaterialsDesigned';
import IconCalendar from 'components/icons/iconCalendar';
import IconDeliveryFlat from 'components/icons/iconDeliveryFlat';
import IconClock from 'components/icons/IconClock';
import iconPremiumDelivery from 'components/icons/iconPremiumDelivery';
import IconAffirmLogo from 'components/icons/iconAffirmLogo';
import PDPValuePropsModalV2 from './PDPValuePropsModalV2';
const ICON_MAP = {
  IconReturns,
  IconMaterialsDesigned,
  IconCalendar,
  IconDeliveryFlat,
  IconClock,
  iconPremiumDelivery,
  IconAffirmLogo
};
const PDPKeySellingPointsV2 = () => {
  const $ = _c(11);
  const {
    loading,
    data
  } = usePDPKeySellingPoints();
  const [activePanel, setActivePanel] = useState(null);
  if (loading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="flex flex-col justify-center mt-8 p-0 w-full"><ul className="items-center flex justify-center list-none m-0 p-0">{[0, 1, 2].map(_temp)}</ul></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!data || data.length === 0) {
    return null;
  }
  let t0;
  if ($[1] !== data) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = (item, index) => {
        const iconData = item.icon;
        const IconComponent = ICON_MAP[iconData.name];
        return IconComponent ? <li className="items-center flex flex-col justify-center list-none m-0 p-0" key={`ksp-${item.id || index}`}><button type="button" className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand" onClick={() => setActivePanel(item)}><div className="flex items-center justify-center mb-2"><IconComponent aria-hidden="true" color="currentColor" height={iconData.height || 26} width={iconData.width || 26} /></div><span className="max-[767px]:max-w-[90px]">{item.label}</span></button></li> : null;
      };
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    t0 = data.map(t1);
    $[1] = data;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = <ul className="items-center flex justify-center list-none m-0 p-0">{t0}</ul>;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== activePanel) {
    t2 = activePanel && <StandardModal isOpen={true} title={activePanel.label} icon={(() => {
      const Icon = ICON_MAP[activePanel.icon?.name];
      return Icon ? <div className="[&_g]:stroke-[#fff]"><Icon width={25} height={30} color="#ffffff" /></div> : null;
    })()} onClose={() => {
      setActivePanel(null);
    }}><PDPValuePropsModalV2 description={activePanel.description} /></StandardModal>;
    $[6] = activePanel;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="flex flex-col justify-center mt-8 p-0 w-full">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default PDPKeySellingPointsV2;
function _temp(idx) {
  return <li className="items-center flex flex-col justify-center list-none m-0 p-0" key={`PDPKeySellingPointsV2__item${idx}`}><div className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand [&_span]:max-[767px]:max-w-[90px]"><div className="flex items-center justify-center mb-2"><Placeholder type="round" loading={true} style={{
          height: 36,
          width: 36
        }} /></div><span className="max-[767px]:max-w-[90px]"><Placeholder type="rect" loading={true} style={{
          height: 12,
          width: 120
        }} /></span></div></li>;
}